<div class="wrapper">
  <span class="title">UV-C Sanitization</span>
  <div class="content">
    <p>
      You are attempting to enable the sanitization feature which will clean the water closet, shower, and kitchen area using UV-C lighting.
    </p>
    <p>
      UV-C lighting is not recommended for living organisms so make sure pets or plants are not placed in the affected area.
    </p>
    <p>
      This feature will only turn on when the alarm is set and your home has been empty for 30 minutes. The cleaning feature will run for 40 minutes.
    </p>
    <ion-img
      src="assets/UV-C-pic.png"
    ></ion-img>

    <div class="content-confirm">
      <div class="content-confirm_row">
        <span class="content-confirm_label">
          I understand that UV-C lighting doesn’t replace the need for cleaning.
        </span>
        <ion-checkbox [checked]="haveConfirmAboutCleaning" (ionChange)="confirmAboutCleaning($event)"></ion-checkbox>
      </div>
      <div class="content-confirm_row">
        <span class="content-confirm_label">
          I confirm there are no pets or plants in the highlighted areas.
        </span>
        <ion-checkbox [checked]="haveConfirmAboutPets" (ionChange)="confirmAboutPets($event)"></ion-checkbox>
      </div>
      <div class="content-confirm_row">
        <span
        *ngIf="haveConfirmAboutCleaning && haveConfirmAboutPets"
          class="continue_btn"
          (click)="confirmed.emit()"
        >Continue</span>
      </div>
    </div>
  </div>
</div>